import { useSpatial } from "../SpatialContext";
import { describeCalendarReceipt, isGhostEvent } from "../../lib/lumenCalendar";
import { describePlanReceipt, planStatus } from "../../lib/dayPlanProposal";
import { toDateKey } from "../../lib/plannerItems";

export default function CalendarReceiptLine({ receipts, onDark = false }) {
  const { surfaceState, confirmCalendarEvent, deleteCalendarEvent, acceptDayPlan, dismissDayPlan } = useSpatial();
  if (!receipts?.length) return null;
  const events = surfaceState?.calendarEvents || [];
  const plannerItems = surfaceState?.plannerItems || [];
  const todayKey = toDateKey();

  const ok = onDark ? "#7DD8D5" : "#2F8F8C";
  const warn = onDark ? "#F6C27A" : "#B45309";
  const muted = onDark ? "rgba(255,255,255,0.55)" : "#94A3B8";
  const buttonStyle = {
    padding: "4px 10px", borderRadius: 8, fontSize: 11, fontWeight: 600, cursor: "pointer", fontFamily: "'DM Sans', sans-serif",
    background: onDark ? "rgba(255,255,255,0.08)" : "white",
    border: `1px solid ${onDark ? "rgba(125,216,213,0.5)" : "rgba(77,184,181,0.45)"}`,
    color: ok,
  };
  const quietStyle = { ...buttonStyle, border: "1px solid transparent", background: "transparent" };
  const choices = (onYes, onNo, yes) => (
    <div style={{ display: "flex", gap: 6, marginTop: 6 }}>
      <button type="button" style={buttonStyle} onClick={onYes}>{yes}</button>
      <button type="button" style={quietStyle} onClick={onNo}>Dismiss</button>
    </div>
  );
  const note = (text, color) => <div style={{ marginTop: 4, fontSize: 11, color }}>{text}</div>;

  return (
    <div style={{ marginTop: 6, whiteSpace: "normal", fontFamily: "'DM Sans', sans-serif" }}>
      {receipts.map((receipt, i) => {
        const isPlan = receipt.kind === "plan";
        const failed = receipt.action === "failed";
        const waiting = receipt.action === "suggested" || receipt.action === "plan_suggested";
        const icon = failed ? "⚠ " : waiting ? "○ " : "✓ ";
        const text = isPlan ? describePlanReceipt(receipt, todayKey) : describeCalendarReceipt(receipt);
        let follow = null;
        if (isPlan && receipt.action === "plan_suggested") {
          const status = planStatus(plannerItems, receipt.planId);
          if (status === "pending") follow = choices(() => acceptDayPlan(receipt.planId), () => dismissDayPlan(receipt.planId), "Accept");
          else if (status === "accepted") follow = note("Accepted.", ok);
          else follow = note("Dismissed.", muted);
        } else if (!isPlan && receipt.action === "suggested") {
          const live = receipt.eventId ? events.find((e) => e.id === receipt.eventId) : null;
          if (live && isGhostEvent(live)) follow = choices(() => confirmCalendarEvent(live.id), () => deleteCalendarEvent(live.id), "Confirm");
          else if (live) follow = note("Confirmed.", ok);
          else follow = note("Dismissed.", muted);
        }
        return (
          <div key={`${receipt.eventId || receipt.planId || "x"}-${i}`} style={{ marginTop: i ? 6 : 0 }}>
            <div role="status" style={{ fontSize: 11, fontWeight: 600, lineHeight: 1.5, color: failed ? warn : ok }}>
              {icon}{text}
            </div>
            {follow}
          </div>
        );
      })}
    </div>
  );
}
